import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminFooter from '../../CommonComponents/AdminFooter'
import AdminHeader from '../../CommonComponents/AdminHeader'
import {
  getActSection,
  getChildrenList,
  GetStudentAdmissionDataById,
  IMG_URL,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const AdmissionReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [reportData, setReportData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [actSectionList, setActSectionList] = useState([])

  useEffect(() => {
    fetchStudents()
    fetchActSections()
  }, [])

  const fetchActSections = async () => {
    try {
      const res = await axios.get(getActSection)
      setActSectionList(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const getActSectionNames = (ids) => {
    if (!ids) return '-'

    const idArray = ids.split(',').map(Number)

    return idArray
      .map((id) => {
        const found = actSectionList.find((item) => item.id === id)
        return found ? found.act_and_sec : null
      })
      .filter(Boolean)
      .join(', ')
  }

  const fetchStudents = async () => {
    const res = await axios.get(getChildrenList)
    setStudents(res.data)
  }

  const fetchReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(
        `${GetStudentAdmissionDataById}/${selectedStudent}`,
      )
      setReportData(Array.isArray(res.data) ? res.data[0] : res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const isPDF = (file) => {
    return file?.toLowerCase().endsWith('.pdf')
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">Admission Report</h3>
          </div>
          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                    {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : (
            reportData && (
              <div className="a4-page">
                {/* HEADER */}
                <div className="text-center pb-3">
                  <h2>
                    <b>सेंट क्रिस्पिन्स होम</b>
                  </h2>
                  <h4>
                    <b>संचालित बालगृह</b>
                  </h4>
                  <h6>
                    <b>बालकाचा प्राथमिक अहवाल</b>
                  </h6>
                </div>

                {/* BASIC INFO */}
                <div className="section">
                  <div className="row p-0 m-0">
                    <div className="row p-0 m-0 align-items-start">
                      <div className="col-9 ">
                        <div className="row ">
                          <div className="col-12">
                            <p>
                              1) <b>बालक चे संपूर्ण नाव:</b> {reportData.fname}{' '}
                              {reportData.mname} {reportData.lname}
                            </p>
                          </div>

                          <div className="col-12">
                            <p>
                              <b>2) प्रवेश दिनांक:</b>{' '}
                              {reportData.admission_date}
                            </p>
                          </div>

                          <div className="col-12">
                            <p>
                              <b>3) जन्मतारीख:</b> {reportData.birth_date}
                            </p>
                          </div>

                          <div className="col-12">
                            <p>
                              <b>4) जन्मस्थान:</b> {reportData.birth_place}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-3 d-flex justify-content-center">
                        {reportData.pic ? (
                          <img
                            src={`${IMG_URL}${reportData.pic}`}
                            alt="student"
                            className="student-photo"
                          />
                        ) : (
                          <div className="student-photo placeholder">
                            No Image
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <p>
                        <b>5) लिंग:</b>{' '}
                        {reportData.gender === 1 ? 'मुलगा' : 'मुलगी'}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>6) धर्म:</b> {reportData.religion.religion_name}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>7) जात / पोटजात :</b> {reportData.caste.cast_name} /{' '}
                        {reportData.sub_caste?.subcast_name}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>8) आधार क्रमांक:</b> {reportData.aadhar_no}
                      </p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        <b>9) Track the Child No:</b> {reportData.child_no}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>10) संपूर्ण पत्ता:</b> {reportData.current_address}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>11) कायमचा पत्ता:</b> {reportData.permanent_address}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>12) संपर्क क्र पालक:</b> {reportData.parent_mobile}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        <b>13) पोलीस स्टेशन व संपर्क क्र:</b>{' '}
                        {reportData.police_station_name}/
                        {reportData.police_contact}
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAMILY TABLE */}
                <div className="section">
                  <p>
                    <b>14) कौटुंबिक माहिती -</b>
                  </p>

                  <table>
                    <thead>
                      <tr>
                        <th>नाव</th>
                        <th>नाते</th>
                        <th>वय</th>
                        <th>व्यवसाय</th>
                        <th>संपर्क</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.familyMembers?.map((f, i) => (
                        <tr key={i}>
                          <td>{f.name}</td>
                          <td>{f.relation}</td>
                          <td>{f.age}</td>
                          <td>{f.occupation}</td>
                          <td>{f.contact}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* CWC */}
                <div className="section">
                  {reportData.child_welfare_committee_details?.map((c, i) => (
                    <div key={i}>
                      <p>
                        15) <b>बाल कल्याण समिती</b> आदेश दिनांक:{' '}
                        {c.first_filed_order_date}
                      </p>
                      <p>
                        आदेश स्वरूप:{' '}
                        {c.form_of_order === 1 ? 'लेखी' : 'व्हॉट्सअ‍ॅप'}
                      </p>
                      <p>
                        कायदा व कलम: {getActSectionNames(c.act_and_section_id)}
                      </p>
                      <p>बालका विषयक तपशील: {c.child_details}</p>
                    </div>
                  ))}
                </div>

                {/* MEDICAL */}
                <div className="section">
                  <p>
                    <b>B) वैद्यकीय माहिती -</b>
                  </p>
                  <div className="row p-0 m-0">
                    <div className="col-12 col-md-4">
                      <p>1) वजन: {reportData.medicalinfo?.weight}</p>
                    </div>
                    <div className="col-12 col-md-4">
                      <p>2) उंची: {reportData.medicalinfo?.height}</p>
                    </div>
                    <div className="col-12 col-md-4">
                      <p>3) रक्तगट: {reportData.medicalinfo?.blood_group}</p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>
                        4) मासिक पाळीची तारीख:{' '}
                        {reportData.medicalinfo?.menstrual_cycle_date}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        5) आरोग्याचा इतिहास व सद्य स्थिती:{' '}
                        {reportData.medicalinfo?.health_history}
                      </p>
                    </div>
                    <div className="col-12">
                      <p>
                        6) जन्म खून किंवा शरीरावरील इतर खून:{' '}
                        {reportData.medicalinfo?.birth_mark_on_body}
                      </p>
                    </div>
                  </div>
                </div>

                {/* EDUCATION */}
                <div className="section">
                  <p>
                    <b>C) शैक्षणिक माहिती -</b>
                  </p>
                  <div className="row p-0 m-0">
                    <div className="col-12 col-md-6">
                      <p>1) इयत्ता: {reportData.educationinfo?.standard}</p>
                    </div>
                    <div className="col-12 col-md-6">
                      <p>2) माध्यम: {reportData.educationinfo?.medium}</p>
                    </div>
                    <div className="col-12">
                      <p>
                        3) शाळेचे नाव: {reportData.educationinfo?.school_name}
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAMILY BACKGROUND */}
                <div className="section">
                  <p>
                    <b>D) कौटुंबिक पार्श्वभूमी व सद्य स्थिती -</b>
                  </p>

                  {reportData.family_background?.map((f, i) => (
                    <div key={i}>
                      <p>1) भेट देणाऱ्याचे नाव: {f.visitor_name}</p>
                      <p>नाते: {f.visitor_relation}</p>
                      <p>
                        2) जबाबदारी घेणारी व्यक्ती पालकांच्या मृत्यू नंतर नाव:{' '}
                        {f.person_name}
                      </p>
                      <p>नाते: {f.visitor_relation}</p>
                      <p>
                        <b>E) बालकांच्या प्रकरणाचा इतिहास:</b>{' '}
                        {f.children_case_history}
                      </p>
                    </div>
                  ))}
                </div>

                {/* ROOM ALLOTMENT DETAILS */}
                  <div className="section">
                    <p>
                      <b>F) रूम वाटप माहिती -</b>
                    </p>

                    {reportData?.room_allocate?.map((room, i) => (
                      <div className="row p-0 m-0" key={i}>
                        <div className="col-12 col-md-6">
                          <p>
                            <b>वाटप दिनांक:</b> {room?.allocation_date || '-'}
                          </p>
                        </div>

                        <div className="col-12 col-md-6">
                          <p>
                            <b>इमारत:</b> {room?.building?.building_name || '-'}
                          </p>
                        </div>

                        <div className="col-12 col-md-6">
                          <p>
                            <b>विंग:</b> {room?.wing?.wing_name || '-'}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
               

                {/* FOOTER */}
                <div className="section">
                  <div className="row p-0 m-0 pt-5">
                    <div className="col-12 col-md-6 text-md-start">
                      <p>
                        <b>सोशल वर्कर</b>
                      </p>
                    </div>
                    <div className="col-12 col-md-6 text-md-end">
                      <p>अलका चांदोरीकर</p>
                      <p>
                        <b>अधिक्षिका</b>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <div className="col-12">
                    <p>
                      <b>शाळा सोडल्याचा दाखला:</b>
                    </p>

                    {reportData.educationinfo?.school_leaving_certificate ? (
                      isPDF(
                        reportData.educationinfo?.school_leaving_certificate,
                      ) ? (
                        <iframe
                          src={`${IMG_URL}${reportData.educationinfo?.school_leaving_certificate}`}
                          title="PDF Viewer"
                          className="pdf-viewer"
                        />
                      ) : (
                        <img
                          src={`${IMG_URL}${reportData.educationinfo?.school_leaving_certificate}`}
                          className="doc-img"
                          alt="home-visit"
                        />
                      )
                    ) : (
                      <p>उपलब्ध नाही</p>
                    )}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`

      .student-photo {
          width: 150px;
          height: 140px;
          object-fit: cover;
          border: 1px solid black;
        }

        .student-photo.placeholder {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px; 
          border: 1px solid red;
        }

        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          {/* margin: auto; */}
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .section {
          margin-bottom: 20px;
        }
        .section p {
          color: black;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        table, th, td {
          border: 1px solid black;
        }

        th, td {
          padding: 6px;
          text-align: left;
        }

        .text-center {
          text-align: center;
        }

       @media print {

          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

           /* FIX ROW */
          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          /*  FIX COLUMNS */
          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          /* remove extra spacing */
          .row > div {
            padding: 2px !important;
          }

          .certificate-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }

        }
      `}</style>
    </>
  )
}

export default AdmissionReport
